import axios from "axios";
import { API, getOrCreateUserId } from "./api";

/**
 * Atomically spend gems for an in-game power-up.
 * Returns the new balance on success, or null if the user can't afford.
 * Throws on network error so callers can surface a toast.
 */
export async function spendGems(reason) {
  const user_id = getOrCreateUserId();
  try {
    const res = await axios.post(`${API}/gems/spend`, { user_id, reason });
    return res.data; // { ok, spent, reason, gems }
  } catch (e) {
    const status = e?.response?.status;
    if (status === 402) return null; // not enough — caller decides what to do
    throw e;
  }
}

// Local mirror of the server-side price table — used for confirmation prompts
// only. Server is the source of truth. Out-of-sync prices will surface as a
// 402 / 400 from the server.
export const GEM_PRICES = {
  reroll: 5,
  hint: 10,
  continue: 50,
};
